var acc = document.querySelectorAll(".cateTitle");
var i;
for ( i = 0; i < acc.length; i++ ){
    acc[i].onclick = function() {
    this.classList.toggle('active');
    var panel = this.nextElementSibling;
    if ( panel.style.display ){
      panel.style.display = null;
    } else {
      panel.style.display = "block";
      panel.style.opacity = 1;
    }
  }
}